import { AppConfig } from '../utils/AppConfig';
import { useIonRouter } from '@ionic/react';
import { useCallback } from 'react';

export const useAppNavigation = () => {
  const ionRouter = useIonRouter();

  const navigate = useCallback((path: string) => {
    ionRouter.push(path);
  }, [ionRouter]);

  const getCurrentPathname = useCallback(() => {
    return ionRouter.routeInfo.pathname;
  }, [ionRouter]);

  const goBack = useCallback(() => {
    ionRouter.back();
  }, [ionRouter]);

  const getCurrentLocale = useCallback(() => {
    const pathname = getCurrentPathname();
    const match = pathname.match(new RegExp(`^/(${AppConfig.locales.join('|')})(/|$)`));
    return match ? match[1] : AppConfig.defaultLocale;
  }, [getCurrentPathname]);

  const isActive = useCallback((path: string) => {
    const currentPath = getCurrentPathname();
    return currentPath === path || currentPath.startsWith(`${path}/`);
  }, [getCurrentPathname]);

  const getParams = useCallback(() => {
    return new URLSearchParams(window.location.search);
  }, []);

  return {
    navigate,
    getCurrentPathname,
    goBack,
    getCurrentLocale,
    isActive,
    getParams,
    canGoBack: ionRouter.canGoBack(),
  };
};
